module.exports = __webpack_public_path__ + "img/MEDIA004.5335e694.jpg";